import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import PaperContainer from 'ui/PaperContainer';

import Banner from '../../../../../images/cc/password-boss-integration-with-control.png';
import controlLogo from '../../../../../images/cc/connectwise_control_black_logo.png';
import BrandLink from '../../../../BrandLink';

const useStyles = makeStyles(theme => ({
    text: {
        fontWeight: 400,
    },
    content: {
        margin: '16px 0',
    },
    logo: {
        margin: '24px 0px',
    },
    banner: {
        margin: '8px 0 8px 0',
        width: '75%',
    },
    helpLink: {
        '& a': {
            textDecoration: 'none',
            color: theme.palette.text.blue,
            fontWeight: 500,
        },
        marginTop: '24px',
        marginBottom: '48px',
    },
}));

export default () => {
    const classes = useStyles();
    return (
        <PaperContainer center>
            <img
                src={controlLogo}
                className={classes.logo}
                alt="ConnectWise Control"
            />
            <Typography variant="h6" gutterBottom className={classes.text}>
                Login to Control session using CyberFOX Password Manager
            </Typography>
            <img
                src={Banner}
                className={classes.banner}
                alt="ConnectWise Control"
            />
            <Typography variant="body1" className={classes.content}>
                One-click login to remote systems.
            </Typography>
            <Typography variant="body1" className={classes.content}>
                No wasted time searching for passwords.
            </Typography>
            <Typography variant="body1" className={classes.content}>
                Install now from the Control Extension store.
            </Typography>
            <Typography component="div" className={classes.helpLink}>
                <BrandLink name="connectwise_control_setup_guide_url">
                    ConnectWise Control Setup Guide
                </BrandLink>
            </Typography>
        </PaperContainer>
    );
};
